var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 5349"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0e2240",
    "data-name": "Group 5915"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16.793H0V0h16.609v5.791h-1.5V1.5H1.5Z",
    "data-name": "Path 4790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.901 23.296-9.9-5.288V0l9.9 5.288Zm-8.4-6.044 6.9 3.686V6.044L1.5 2.358Z",
    "data-name": "Path 4791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.589 9.522H11.002v-1.5h11.587Z",
    "data-name": "Line 1857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.61 18.394H9.393v-1.5h5.717v-5.971h1.5Z",
    "data-name": "Path 4792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.899 14.873-1.061-1.061 5.041-5.041-5.041-5.04 1.061-1.061 6.1 6.1Z",
    "data-name": "Path 4793"
  }))));
};
export default SvgLogout;